{
  "name": "lautec-q",
  "version": "2.4.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-test": "ng build --configuration testing",
    "build-prod": "ng build --configuration production",
    "build-demo": "ng build --configuration demo",
    "preview": "vite preview",
    "test": "vitest",
    "test:ci": "vitest run",
    "test:affected": "bun run test:affected:branch --base origin/master",
    "test:affected:worktree": "node .claude/scripts/select-vitest-tests.mjs --source worktree",
    "test:affected:staged": "node .claude/scripts/select-vitest-tests.mjs --source staged",
    "test:affected:branch": "node .claude/scripts/select-vitest-tests.mjs --source branch",
    "test:c3-scope": "vitest run src/app/core/interceptors/client.interceptor.spec.ts src/app/core/interceptors/project.interceptor.spec.ts src/app/core/stores/account.store.spec.ts src/app/core/stores/access.store.spec.ts src/app/core/stores/app.store.spec.ts src/app/shared/services/app-initializer.service.spec.ts src/app/shared/components/client-setup/client-setup.component.spec.ts src/app/shared/components/project-setup/project-setup.component.spec.ts",
    "test:governance": "bun run test:governance:vitest && bun run test:bitbucket-pr",
    "test:governance:vitest": "vitest run --config vitest.governance.config.ts",
    "test:bitbucket-pr": "node .claude/scripts/run-bitbucket-pr-tests.mjs",
    "test:changelog": "bun test ./pipelines/tests/changelog-generation.test.js",
    "test:tenant-scope-rule": "vitest run --config vitest.governance.config.ts tools/eslint-rules/no-tenant-scope-bypass.test.mjs",
    "test:golden-principles": "vitest run --config vitest.governance.config.ts .claude/scripts/tests/validate-golden-principles.test.mjs .claude/scripts/tests/validate-golden-principles-review.test.mjs tools/eslint-rules/no-tenant-scope-bypass.test.mjs",
    "test:docs-rules": "vitest run --config vitest.governance.config.ts .claude/scripts/tests/docs-rules-check.test.mjs",
    "test:docs": "vitest run --config vitest.governance.config.ts .claude/scripts/tests/validate-docs.test.mjs .claude/scripts/tests/docs-rules-check.test.mjs",
    "test:format-check-changed": "vitest run --config vitest.governance.config.ts .claude/scripts/tests/format-check-changed.test.mjs",
    "test:agentic-engineering": "vitest run --config vitest.governance.config.ts .claude/scripts/tests/validate-agentic-engineering.test.mjs",
    "lint": "ng lint --max-warnings=0",
    "release": "semantic-release --branches \"$RELEASE_BRANCH\" && git push origin HEAD --tags",
    "release-patch": "semantic-release --extends \"$SR_BRANCH_CONFIG_PATH\" && git push origin HEAD --tags",
    "release:dry": "semantic-release --dry-run --branches \"$RELEASE_BRANCH\"",
    "release-patch:dry": "semantic-release --dry-run --extends \"$SR_BRANCH_CONFIG_PATH\"",
    "format": "prettier \"src/**/*.{ts,json,scss,html}\" --write",
    "format:check": "prettier \"src/**/*.{ts,json,scss,html}\" --check",
    "format:check:changed": "node .claude/scripts/format-check-changed.mjs",
    "format:write": "prettier \"src/**/*.{ts,json,scss,html}\" --write",
    "lint:fix": "ng lint --fix",
    "validate:golden-principles": "node .claude/scripts/validate-golden-principles.mjs",
    "validate:golden-principles-review": "node .claude/scripts/validate-golden-principles-review.mjs",
    "validate:docs": "node .claude/scripts/validate-docs.mjs",
    "validate:agentic-engineering": "node .claude/scripts/validate-agentic-engineering.mjs",
    "preinstall": "node .claude/scripts/validate-toolchain.mjs",
    "validate:toolchain": "node .claude/scripts/validate-toolchain.mjs",
    "prepare": "husky install"
  },
  "engines": {
    "node": "24.14.0",
    "bun": "1.3.1"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --max-warnings=0",
      "prettier --write"
    ],
    "*.{js,mjs,cjs,json,jsonc,scss,css,yaml,yml}": [
      "prettier --write"
    ],
    "*.md": [
      "prettier --write",
      "markdownlint-cli2 --config .claude/markdownlint-cli2.jsonc"
    ],
    "{src/**/*.{ts,html},eslint.config.mjs,tools/eslint-rules/**,.claude/governance/**,.claude/rules/golden-principles.md,.claude/scripts/validate-golden-principles*.mjs,.claude/scripts/lib/changed-files.mjs,.claude/scripts/lib/review-snapshot.mjs,.claude/scripts/tests/validate-golden-principles*.test.mjs,.claude/skills/golden-principles-maintenance/**,docs/**,openspec/**,CLAUDE.md,AGENTS.md,package.json}": [
      "bun run validate:golden-principles",
      "bun run validate:golden-principles-review -- --source staged"
    ],
    "{eslint.config.mjs,.claude/governance/tenant-scope-policy.json,tools/eslint-rules/no-tenant-scope-bypass.mjs,tools/eslint-rules/no-tenant-scope-bypass.test.mjs}": [
      "bun run test:tenant-scope-rule"
    ],
    "{CLAUDE.md,AGENTS.md,package.json,.node-version,.mcp.json,openspec/config.yaml,.claude/scripts/validate-toolchain.mjs,.claude/scripts/validate-agentic-engineering.mjs,.claude/scripts/tests/validate-agentic-engineering.test.mjs,pipelines/*.yaml}": [
      "bun run validate:agentic-engineering"
    ],
    "{.claude/commands/pr.md,.claude/rules/bitbucket-integration.md,.claude/scripts/bitbucket-pr.ps1,.claude/scripts/bitbucket-comment.ps1,.claude/scripts/run-bitbucket-pr-tests.mjs,.claude/scripts/lib/powershell.mjs,.claude/scripts/tests/bitbucket-pr.tests.ps1}": [
      "bun run test:bitbucket-pr"
    ]
  },
  "commitlint": {
    "extends": [
      "@commitlint/config-conventional"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.2",
    "@angular/cdk": "^20.2.13",
    "@angular/common": "^20.3.2",
    "@angular/compiler": "^20.3.2",
    "@angular/core": "^20.3.2",
    "@angular/forms": "^20.3.2",
    "@angular/material": "^20.2.13",
    "@angular/platform-browser": "^20.3.2",
    "@angular/platform-browser-dynamic": "^20.3.2",
    "@angular/router": "^20.3.2",
    "@azure/msal-angular": "^4.0.20",
    "@azure/msal-browser": "^4.24.0",
    "@microsoft/applicationinsights-web": "^3.3.10",
    "@ngrx/component": "^20.0.1",
    "@ngrx/effects": "^20.0.1",
    "@ngrx/operators": "^20.0.1",
    "@ngrx/signals": "^20.1.0",
    "@ngrx/store": "^20.0.1",
    "@ngrx/store-devtools": "^20.0.1",
    "bootstrap": "^5.3.8",
    "dayjs": "^1.11.18",
    "leaflet": "~1.9.4",
    "leaflet-draw": "~1.0.4",
    "leaflet.markercluster": "^1.5.3",
    "lodash": "^4.17.21",
    "ng-lazyload-image": "^9.1.3",
    "ngx-extended-pdf-viewer": "^24.3.1-alpha.1",
    "ngx-mat-select-search": "^8.0.2",
    "ngx-quill": "^28.0.1",
    "ngx-toastr": "^19.1.0",
    "quill": "^2.0.3",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^1.14.0",
    "@angular-eslint/builder": "20.3.0",
    "@angular/build": "^20.3.3",
    "@angular/cli": "^20.3.3",
    "@angular/compiler-cli": "^20.3.2",
    "@angular/language-service": "^20.3.2",
    "@commitlint/cli": "^19.8.1",
    "@commitlint/config-conventional": "^19.8.1",
    "@eslint/compat": "^1.4.0",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.36.0",
    "@fission-ai/openspec": "1.10.0",
    "@semantic-release/changelog": "6.0.3",
    "@semantic-release/commit-analyzer": "13.0.1",
    "@semantic-release/git": "10.0.1",
    "@semantic-release/npm": "13.1.5",
    "@semantic-release/release-notes-generator": "14.1.1",
    "@types/bootstrap": "^5.2.10",
    "@types/leaflet": "^1.9.20",
    "@types/leaflet-draw": "^1.0.13",
    "@types/leaflet.markercluster": "^1.5.6",
    "@types/lodash": "^4.17.20",
    "@types/node": "^24.5.2",
    "@types/quill": "^2.0.14",
    "@typescript-eslint/types": "8.44.1",
    "ajv": "~8.17.1",
    "ajv-formats": "~3.0.1",
    "angular-eslint": "^20.3.0",
    "baseline-browser-mapping": "^2.9.18",
    "eslint": "^9.36.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-rxjs-x": "^0.7.7",
    "eslint-plugin-unused-imports": "^4.2.0",
    "husky": "^9.1.7",
    "jsdom": "^25.0.1",
    "lint-staged": "^16.2.1",
    "markdownlint-cli2": "^0.23.2",
    "ngrx-store-freeze": "^0.2.4",
    "pagedjs": "^0.4.3",
    "prettier": "^3.6.2",
    "prettier-eslint": "^16.4.2",
    "sass": "^1.93.2",
    "conventional-changelog-conventionalcommits": "9.3.1",
    "semantic-release": "25.0.8",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.44.1",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^3.2.4",
    "yaml": "~2.8.1"
  },
  "packageManager": "bun@1.3.1"
}
